export default __webpack_public_path__ + "static/media/img20.b787cad1.svg";